import React, {useEffect, useRef, useState} from 'react';
import {useGetAddressTypesQuery} from '../../redux/rtk/injectedMappingApi';
import {useLazyGetHereAddressQuery} from '../../redux/rtk/injectedHereAddressApi';
import {useFieldArray} from 'react-hook-form';
import Input from '../global/Input';
import {Button} from 'primereact/button';
import {TabPanel, TabView} from 'primereact/tabview';
import {RadioButton} from 'primereact/radiobutton';
import CustomDialog from '../global/CustomDialog';
import MapOl from '../geoData/map';
import LayersMapOl from '../geoData/layer/LayersMapOl';
import BaseLayers from '../geoData/layer/BaseLayers';
import OverlayLayer from '../geoData/layer/OverlayLayer';
import ConfigLayers from '../geoData/layer/ConfigLayers';
import {getMapCenter} from '../../functions/functionsOpenlayer';
import {setBaseLayer, setBaseWorkspace, setWorkspace} from '../../redux/slices/GeomonitoringSlice';
import {useAppDispatch} from '../../redux/hooks';
import geoSettings from '../../config/geoSettings';
import PoiLayer from '../geoData/layer/PoiLayer';
import {useGetKontaktTypesQuery} from '../../redux/rtk/injectedPersonApi';
import {CustomConfirmDialog} from '../global/CustomConfirmDialog';

type AddressProps = {
    projectId: string,
    t: any,
    getFormErrorMessage: (name: string) => void,
    form: any,
    istJuristisch: boolean,
    edit: boolean,
}

export const ContactForm = (props: AddressProps) => {
    const [contactTypes, setContactTypes] = useState<any>([]);
    const [selectedContactType, setSelectedContactType] = useState<any>();

    const contactTypesQuery = useGetKontaktTypesQuery();
    const t = props.t;
    const {control, formState: {errors}, handleSubmit, setValue, getValues, watch} = props.form;

    const id = 'kontakt';

    const {fields, append, prepend, remove, swap, move, insert} = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormContext)
        name: id, // unique name for your Field Array
    });

    useEffect(() => {
        if (contactTypesQuery.data) {
            setContactTypes(contactTypesQuery.data.filter((item: any) => {
                return item.ist_juristisch === props.istJuristisch;
            }).map((item: any) => {
                return {label: item.name, value: item.id};
            }));
        }
    }, [props.istJuristisch, contactTypesQuery.data]);

    const getContactTypeName = (id: number) => {
        let result = '';

        if (contactTypes.length > 0) {
            const temp = contactTypes.filter((item: any) => {
                return item.value === id;
            });

            if (temp.length > 0) {
                result = temp[0].label;
            }
        }
        return result;
    };

    const getContact = (item: any, index: number) => {
        let typeWatch = watch(`${id}.${index}.kontakt_type_id`);

        let button = undefined;

        let pattern = undefined;

        let type = 'text';

        switch (typeWatch) {
            case 1:
            case 2:
            case 6:
            case 7:
                button = <a href={'tel:' + item.value} style={{float: 'right'}}><Button
                    className={'p-button-rounded p-button-text mt-auto mr-3'}
                    type={'button'}
                    icon={'pi pi-external-link'}
                    disabled={!props.edit}/></a>;

                pattern = {
                    value: /^\+[0-9]+$/g,
                    message: t('common:validation.telephoneWrongFormat') + ' (+4912345)'
                };
                break;

            case 3:
                pattern = {
                    value: /^\+[0-9]+$/g,
                    message: t('common:validation.telephoneWrongFormat') + ' (+4912345)'
                };
                break;

            case 4:
            case 9:
                button = <a href={'mailto:' + item.value} style={{float: 'right'}}><Button
                    className={'p-button-rounded p-button-text mt-auto mr-3'}
                    type={'button'}
                    icon={'pi pi-external-link'}
                    disabled={!props.edit}/></a>;
                type = 'email';
                break;
        }

        return (<>
            <div className={'col-12 xl:col-6'}>
                <Input edit={props.edit} name={`${id}.${index}.value`}
                       label={getContactTypeName(getValues(`${id}.${index}.kontakt_type_id`))}
                       type={type}
                       dropdownOptions={contactTypes}
                       validationControl={control}
                       validationErrorMessage={props.getFormErrorMessage}
                       validationRules={{
                           required: getContactTypeName(getValues(`${id}.${index}.kontakt_type_id`)) + ' ' + t('input:required'),
                           pattern: pattern
                       }}
                />
            </div>
            <div className={'col-12 xl:col-6 mt-auto flex mb-3 xl:mb-0'}>
                <Input type={'checkbox'} name={`${id}.${index}.hauptkontakt`}
                       noMargin={true}
                       label={t('globalData:persons.maincontact')}
                       edit={props.edit} disabled={!props.edit}
                       value={`${id}.${index}.hauptkontakt`}
                       onChange={(e) => {
                           if (e.checked) {
                               for (let i = 0; i < fields.length; i++) {
                                   if (index !== i) {
                                       setValue(`${id}.${i}.hauptkontakt`, false);
                                   }
                               }
                           } else {
                               setValue(`${id}.${index}.hauptkontakt`, true);
                           }
                       }}
                       validationControl={control}
                       validationErrorMessage={props.getFormErrorMessage}
                       validationRules={{
                           required: false,
                           // required: t('globalData:persons.streetHouseNr') + ' ' + t('input:required')
                       }}/>

                {button}

                {props.edit &&
                <Button className={'p-button-rounded p-button-danger p-button-text mt-auto'} style={{float: 'right'}}
                        type={'button'}
                        icon={'pi pi-trash'}
                        disabled={!props.edit}
                        onClick={() => {
                            CustomConfirmDialog({
                                message: t('globalData:dialogs.deleteContact'),
                                header: t('confirmDialog:deleteDialogHeader'),
                                translation: t,
                                onConfirm: () => {
                                    remove(index);

                                    let hauptKontaktVorhanden = false;

                                    if (fields.length > 0) {
                                        for (let i = 0; i < fields.length; i++) {
                                            if (index !== i) {
                                                let hk = getValues(`${id}.${i}.hauptkontakt`);

                                                if (hk) {
                                                    hauptKontaktVorhanden = true;
                                                    break;
                                                }
                                            }
                                        }

                                        if (!hauptKontaktVorhanden) {
                                            setValue(`${id}.${0}.hauptkontakt`, true);
                                        }
                                    }
                                }
                            });
                        }}/>}
            </div>
        </>);
    };

    return (
        <div className={'grid'}>
            {props.edit && <>
                <div className={'col-6'}>
                    <Input
                        type="dropdown" edit={props.edit} name={'contactTypes'}
                        label={t('globalData:persons.contactTypes')}
                        dropdownOptions={contactTypes}
                        value={selectedContactType}
                        onChange={(e: any) => {
                            setSelectedContactType(e.target.value);
                        }}
                    />
                </div>
                <div className={'col-6'}>
                    <div className={'relative w-full h-full flex'}>
                        <Button
                            className={'p-button-success p-button-outlined p-button-icon-only absolute'}
                            style={{left: '0', bottom: '0'}}
                            disabled={!props.edit || selectedContactType == null}
                            type={'button'} icon={'pi pi-plus'} onClick={() => {
                            append({
                                'kontakt_type_id': selectedContactType,
                                // 'kontakt_type_name': getContactTypeName(selectedContactType),
                                'hauptkontakt': fields.length <= 0,
                                'value': ''
                            });
                            setSelectedContactType(undefined);
                        }}/>
                    </div>
                </div>
            </>}
            {fields.map((item: any, index: number) => {
                return getContact(item, index);
            })}
        </div>
    );
};
